<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" epub:type="dedication" id="dedication" role="doc-dedication">
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>For my six wonderful friends –</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>Catherine Irwin, Eileen West, Helen Smither,</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>Paula Kane, Theresa Garrod and Tracey Smith.</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>Here’s to the next forty years.</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1cff4162